<template>
  <div class="imports">
    <div class="head">
      <img class="headImg" src="../../assets/logo.png" alt="" />
      <div class="head_content">
        <div class="head_title">订单系统导入平台</div>
      </div>
    </div>
    <div class="importBtn" style="text-align: center;padding-top: .4rem;">
      <button class="btn danger" @click="imports('order')" type="primary">
        订单导入
      </button>
      <button
        class="btn primary"
        @click="imports('architecture')"
        type="primary"
      >
        架构导入
      </button>
    </div>
    <div class="search_bg_img">
      <img class="searchImg" width="100%" src="../../assets/search_bt.png" />
    </div>
    <CommonInport v-if="show" :type="type" @close="close"></CommonInport>
  </div>
</template>
<script>
import { listSearch } from "../../api/";
import CommonInport from "../../components/CommonInport.vue";
export default {
  name: "search",
  data() {
    return {
      show: false,
      type: "order"
    };
  },
  methods: {},
  created() {},
  mounted() {},
  methods: {
    imports(val) {
      this.type = val;
      this.show = true;
    },
    close() {
      this.show = false;
    }
  },
  components: { CommonInport }
};
</script>
<style type="text/css" scoped>
.head {
  width: 100%;
  height: 70px;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(../../assets/search_head.jpg);
  /* display: flex;
  flex-direction: column-reverse; */
}
.headImg {
  z-index: 999;
  position: absolute;
  height: 70px;
}
.head_content {
  /* width: 100%; */
  /* padding: 0.3rem 0.21rem; */
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
}
.head_content .head_title {
  font-size: 26px;
  line-height: 70px;
  font-weight: 400;
  color: #ffffff;
  width: 100%;
  text-align: center;
}
.imports {
  /* margin: 20px; */
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.btn {
  border-radius: 160px;
  font-size: 40px;
  padding: 30px 360px;
  cursor: pointer;
  margin-top: 50px;
  background: rgba(255, 0, 0, 0.5);
  /* border: none; */
  margin: 50px 100px 0;
  /* justify-content: center; */
}
.primary {
  /* background: #c90000;
  color: #fff; */
  /* border: none; */
}
.danger {
  /* background: #fff;
  color: #c90000; */
}
.importBtn {
  z-index: 99;
  position: absolute;
  /* left: calc(100% - 1000px); */
  width: 100%;
  top: 17%;
}
.search_bg_img {
  width: 100vw;
  z-index: -99;
  position: absolute;
}
.searchImg {
  width: 100%;
  height: calc(100% - 260px);
}
</style>



// WEBPACK FOOTER //
// src/views/imports/index.vue